/**
 * manager-groups-menu.js
 */

import React from 'react';
import { useMediaQuery, IconButton } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { useHistory, matchPath, Link } from 'react-router-dom';
import DrawerMenu from 'components/menu-drawer/menu/drawer-menu';
import DrawerMenuItem from 'components/menu-drawer/menu/drawer-menu-item';
import Icon from 'components/icon';
import AppBar from 'components/app-bar';
import CaptionedSvg from 'components/captioned-svg';
import RequestType from '../request-type';
import { ManagerGroupsContext } from './manager-groups-context';
import { managerGroupRoute } from './manager-groups';
import ManagerGroupAdd from './manager-group-add';
import { ReactComponent as GroupsImage } from 'assets/images/groups.svg';
import { ReactComponent as ProjectTeamSvg } from 'assets/images/project-team.svg';
import ScrollableList from 'components/scrollable-list/scrollable-list';


const useStyles = makeStyles(theme => ({
  roleTag: {
    textTransform: 'uppercase',
    fontSize: theme.typography.sizes[0],
  }
}));


export default function ManagerGroupsMenu(props) {
  const { basePath } = props;
  const classes = useStyles();
  const { managers } = React.useContext(ManagerGroupsContext);
  const isMobileDrawer = useMediaQuery(theme => theme.breakpoints.down('sm_md'), { noSsr: true });
  const history = useHistory();
  const relevantManagers = managers
    .filter(m => isMobileDrawer || m.dateAccepted || m.members)
    .map(m => {
      const to = managerGroupRoute(m.manager.id, m.role.id, history);
      const isActive = Boolean(matchPath(history.location.pathname, { path: to.pathname, exact: true }));
      return { ...m, to, isActive };
    });


  const closeButton = (
    <IconButton
      data-testid="back-button"
      size="small"
      style={{color: 'inherit'}}
      component={Link}
      to={basePath}
      children={<Icon type='mobile-close-drawer' />}
    />
  );


  const addGroupButton = (
    <ManagerGroupAdd 
      menuLabel={<IconButton
        data-testid='add-manager-group'
        size='small'
        style={{ color: 'inherit' }}  
        children={<Icon type='add' />}      
      />}
    />
  )


  const menuItems = <>
    {relevantManagers.map(m => (
      <DrawerMenuItem
        key={`manager-menu-${m.id}`}
        to={m.to}
        isActive={m.isActive}
        // iconName={'group-manager'}
        iconName={m.role.name.toLowerCase()}
        label={m.manager.name}
        labelSub={<span className={classes.roleTag}>{m.role.name}</span>}
        labelEnd={m.dateAccepted ? m.members?.length : <RequestType context='manager-group' request={m} />}
      />
    ))}
    {isMobileDrawer &&
    <CaptionedSvg
      image={<ProjectTeamSvg />}
      text={<>Use the <b>+</b> button to share your records with a supervisor or trainer.</>}
    />}
  </>


  return (
    <DrawerMenu
      header={isMobileDrawer && <AppBar title='MANAGERS' leftActions={closeButton} rightActions={addGroupButton} />}
      footer={!isMobileDrawer && <GroupsImage />}
      hideDivider={relevantManagers.length === 0}
      menuGroups={[{
        name: '',
        component: ScrollableList,
        scrollable: true,
        items: menuItems
      }]}
    />
  );
}